import Roles from '@/auth/roles';
import TeamForm from './team-form';
import TeamList from './team-list';
import TeamHistoryFull from './team-history/team-history-full/team-history-full';
import TeamHistorySingle from './team-history/team-history-single/team-history-single';
import TeamShow from './team-show';
import playerImport from '../player/player-import/player-import';

const roles = Roles.values;

export default [
  {
    name: 'teamList',
    path: 'team',
    component: TeamList,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamViewer.id,
        roles.teamEditor.id
      ]
    },
    children: [
      {
        name: 'playerImportCsv',
        path: 'team/importCsv',
        components:  {
          playerImport
        }
      }]
  },
  {
    name: 'teamNew',
    path: 'team/new',
    component: TeamForm,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id,
        roles.clubManager.id
      ]
    }
  },
  {
    name: 'teamEdit',
    path: 'team/:id/edit',
    component: TeamForm,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.entityEditor.id,
        roles.teamEditor.id
      ]
    }
  },
  {
    name: 'teamHistorySingle',
    path: 'team/:id/history',
    component: TeamHistorySingle,
    props: true,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'teamHistoryFull',
    path: 'team/history',
    component: TeamHistoryFull,
    meta: {
      auth: true,
      roles: [roles.owner.id, roles.activityViewer.id]
    }
  },
  {
    name: 'teamShow',
    path: 'team/:id',
    component: TeamShow,
    props: true,
    meta: {
      auth: true,
      roles: [
        roles.owner.id,
        roles.activityViewer.id,
        roles.entityViewer.id,
        roles.entityEditor.id,
        roles.teamViewer.id,
        roles.teamEditor.id,
        roles.clubManager.id
      ]
    }
  }
];



// WEBPACK FOOTER //
// ./src/entities/team/team-routes.js